<template>
  <div>
    <v-tabs v-model="tabOpen" color="info" dark show-arrows v-if="analyticalWorksheet">
      <v-tabs-slider color="info darken-2"></v-tabs-slider>
      <v-tab v-for="item in itemsTab" :href="'#tab-' + item" :key="'#tab-' + item" >
       {{item}} </v-tab>
      <v-tabs-items>
        <v-tab-item :value="'tab-Formação de Preços'" v-if="analyticalWorksheet.header">
          <tab-header ref="tab_header"></tab-header>
        </v-tab-item>

        <v-tab-item :value="'tab-Módulo 1'" v-if="analyticalWorksheet.moduleOne">
          <tab-module1></tab-module1>
        </v-tab-item>

        <v-tab-item :value="'tab-Módulo 2'" v-if="analyticalWorksheet.moduleTwo">
          <tab-module2></tab-module2>
        </v-tab-item>

        <v-tab-item :value="'tab-Módulo 3'" v-if="analyticalWorksheet.moduleThree">
          <tab-module3></tab-module3>
        </v-tab-item>

        <v-tab-item :value="'tab-Módulo 4'" v-if="analyticalWorksheet.moduleFour">
          <tab-module4></tab-module4>
        </v-tab-item>

        <v-tab-item :value="'tab-Módulo 5'" v-if="analyticalWorksheet.moduleFive">
          <tab-module5></tab-module5>
        </v-tab-item>

        <v-tab-item :value="'tab-Módulo 6'" v-if="analyticalWorksheet.moduleSix">
          <tab-module6 ref="moduloSeis"></tab-module6>
        </v-tab-item>

        <v-tab-item :value="'tab-Equipamentos'" v-if="analyticalWorksheet.moduleFive">
          <attachment attachment="equipments" filter="Equipamento" :inputsVariables="budget.inputsVariables"></attachment>
        </v-tab-item>

        <v-tab-item :value="'tab-Materiais de Consumo'" v-if="analyticalWorksheet.moduleFive">
          <attachment attachment="consumables" filter="Material de Consumo" :inputsVariables="budget.inputsVariables"></attachment>
        </v-tab-item>

        <v-tab-item :value="'tab-Uniformes e EPIs'" v-if="analyticalWorksheet.moduleFive">
          <attachment attachment="uniformsAndEPIs" filter="Uniforme e EPI's" :inputsVariables="budget.inputsVariables"></attachment>
        </v-tab-item>

        <v-tab-item :value="'tab-Utensílios'" v-if="analyticalWorksheet.moduleFive">
          <attachment attachment="utensils" filter="Utensílio" :inputsVariables="budget.inputsVariables"></attachment>
        </v-tab-item>

        <v-tab-item :value="'tab-Quadro Resumo'" v-if="analyticalWorksheet.moduleOne">
          <tab-summary-table></tab-summary-table>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  // COMPONENTS //
  
  
  import Attachment from "../../components/budget/Attachment";
  import TabHeader from "../../components/budget/TabHeader";
  import TabModule1 from "../../components/budget/TabModule1";
  import TabModule2 from "../../components/budget/TabModule2";
  import TabModule3 from "../../components/budget/TabModule3";
  import TabModule4 from "../../components/budget/TabModule4";
  import TabModule5 from "../../components/budget/TabModule5";
  import TabModule6 from "../../components/budget/TabModule6";
  import TabSummaryTable from "../../components/budget/TabSummaryTable.vue";
  

  export default {
    components: {
      Attachment,
      TabHeader,
      TabModule1,
      TabModule2,
      TabModule3,
      TabModule4,
      TabModule5,
      TabModule6,
      TabSummaryTable
    },
    data: () => ({
      itemsTab: ["Formação de Preços", "Módulo 1", "Módulo 2", "Módulo 3", "Módulo 4", "Módulo 5", "Módulo 6",
        "Equipamentos", "Materiais de Consumo",  "Uniformes e EPIs",  "Utensílios", "Quadro Resumo"
      ],
      tabOpen: 'tab-Formação de Preços'
    }),
    computed: {
      ...mapState({analyticalWorksheet: state => state.budget.analyticalWorksheet}),
      ...mapState({budget: state => state.budget.budget}),
    },
    created() {
      this.$eventHub.$on("initTabs", _ => {
        this.tabOpen = 'tab-' + this.itemsTab[0]
      });      
    },
    methods:{
      /**
       * @returns {Boolean}
       */
      validateComponents(){
        /* Aqui voce pode colocar os resultados das validacões e retornar para o budget  */
        return this.$refs.tab_header.startValidationInVForm()//<--aqui ele chama o metodo do componente com ref="tab_header"
        
      }
    }
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/budget/AnalyticalWorksheet.vue